const customStyles: any = {
  option: (provided: any, state: any) => ({
    ...provided,
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    backgroundColor: state?.isFocused ? '#132846' : '#132846', // Highlighted option color
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    color: state?.isFocused ? '#ffffff' : '#d1d1d1', // Text color
    padding: 10,
  }),
  menu: (provided: any) => ({
    ...provided,
    backgroundColor: '#0f1f36', // Menu background color
    border: '1px solid #132846',
  }),
  control: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: '#0f1f36', // Input background
    border: '1px solid #132846', // Custom border color and width
    borderRadius: '0.25rem', // Optional: Rounded corners
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    borderColor: state?.isFocused ? '#132846' : '#132846',
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    boxShadow: state?.isFocused ? '0 0 0 1px #132846' : 'none',
  }),
  multiValue: (provided: any) => ({
    ...provided,
    backgroundColor: '#132846', // Tag background color
    color: '#ffffff',
  }),
  multiValueLabel: (provided: any) => ({
    ...provided,
    color: '#ffffff', // Tag label color
  }),
  multiValueRemove: (provided: any) => ({
    ...provided,
    color: '#ffffff',
    ':hover': {
      backgroundColor: '#ff4040',
      color: '#ffffff',
    },
  }),
};

export default customStyles;
